"use strict";
/** All objects which are schema-versioned. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaVersions = exports.isLinkNext = exports.linkNextUseableDef = exports.isLinkLatest = exports.linkLatestUseableDef = exports.isKetteNext = exports.ketteNextUseableDef = exports.isKetteLatest = exports.ketteLatestUseableDef = void 0;
const Link1_1 = require("./link/versions/Link1");
const Kette24_1 = require("./kette/versions/Kette24");
const notUsed = {
    latest: '',
    next: '',
};
// -----------------------------------------
// articles having same schema for all apps
const espool = { latest: '5', next: '5' };
const ketteSerie = {
    latest: '11',
    next: '11',
};
const ia = {
    latest: '15',
    next: '15',
};
const kette = { latest: '24', next: '24' };
exports.ketteLatestUseableDef = Kette24_1.kette24UseableDef;
exports.isKetteLatest = Kette24_1.isKette24;
exports.ketteNextUseableDef = Kette24_1.kette24UseableDef;
exports.isKetteNext = Kette24_1.isKette24;
const link = { latest: '1', next: '1' };
exports.linkLatestUseableDef = Link1_1.link1UseableDef;
exports.isLinkLatest = Link1_1.isLink1;
exports.linkNextUseableDef = Link1_1.link1UseableDef;
exports.isLinkNext = Link1_1.isLink1;
const leitungSerie = {
    latest: '9',
    next: '9',
};
const konfektionierung = {
    latest: '10',
    next: '10',
};
const verpackung = {
    latest: '18',
    next: '18',
};
// -----------------------------------------
// EIQ specific
const EIQ = {
    articles: {
        ae: {
            latest: '9',
            next: '9',
        },
        espool,
        fuehrungsrinne: {
            latest: '10',
            next: '10',
        },
        ia,
        kette,
        konfektionierung,
        leitung: {
            latest: '13',
            next: '13',
        },
        link,
        montageSet: {
            latest: '9',
            next: '9',
        },
        montBes: notUsed,
        zubehoer: notUsed,
        verpackung,
        zugentlastung: {
            latest: '10',
            next: '10',
        },
    },
    aeZubehoerRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    befestigungInnenCProfil: notUsed,
    belastungGleitend: notUsed,
    fl: notUsed,
    discounts: {
        latest: '9',
        next: '9',
    },
    discountCriteria: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    discountRule: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    iaKetteSerieRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    iaRefItem: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    kettenSerienSystem: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    langTextArray: notUsed,
    minBauraumRinneRef: notUsed,
    rinnenVariante: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    staticIAArtikelRef: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    zugentlastungMontage: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    zusBreiteFRBefestigung: notUsed,
};
// -----------------------------------------
// EKE specific (also ECF and EIC)
const EKE = {
    articles: {
        ae: {
            latest: '9',
            next: '9',
        },
        espool,
        fuehrungsrinne: {
            latest: '10',
            next: '10',
        },
        ia,
        kette,
        konfektionierung,
        leitung: {
            latest: '13',
            next: '13',
        },
        link,
        montageSet: {
            latest: '8',
            next: '8',
        },
        montBes: notUsed,
        zubehoer: notUsed,
        verpackung,
        zugentlastung: {
            latest: '9',
            next: '9',
        },
    },
    aeZubehoerRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    befestigungInnenCProfil: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    belastungGleitend: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    discounts: notUsed,
    discountCriteria: notUsed,
    discountRule: notUsed,
    fl: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    iaKetteSerieRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    iaRefItem: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    kettenSerienSystem: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    langTextArray: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    minBauraumRinneRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    rinnenVariante: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    staticIAArtikelRef: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    zugentlastungMontage: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    zusBreiteFRBefestigung: {
        latest: '1.0.0',
        next: '1.0.0',
    },
};
exports.schemaVersions = {
    apps: {
        EIQ,
        EKE,
        EIC: EKE,
        ECF: EKE,
        TEST: EKE,
    },
    common: {
        articles: {
            espool,
            ia,
            kette,
            konfektionierung,
            link,
            verpackung,
            // TODO use same schemaversion
            ae: notUsed,
            leitung: notUsed,
            zubehoer: notUsed,
            fuehrungsrinne: notUsed,
            montageSet: notUsed,
            montBes: notUsed,
            zugentlastung: notUsed,
        },
        articleSeries: {
            ketteSerie,
            leitungSerie,
        },
        articleRef: {
            latest: '0.3.0',
            next: '0.3.0',
        },
        countryPrice: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        countryPriceCountry: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        countryPriceCurrency: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        countryText: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        langText: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        ketteSerieCompact: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        ketteSerieGrease: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        rolEchainParts: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        manufacturerArtNr: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        unitNumber: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        espoolLinear: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        espoolTwisterband: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        fileDataRecord: {
            latest: '0.1.1',
            next: '0.1.1',
        },
        ketteSerieRef: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        iaRefItem: {
            latest: '0.1.0',
            next: '0.1.0',
        },
    },
};
//# sourceMappingURL=schemaVersions.js.map